import { ActivityInstallations } from '@things-factory/worklist'

import { ActivityDataCollect } from './activity-data-collect.js'
import { ActivityDataReview } from './activity-data-review.js'
import { ActivityOocResolve } from './activity-ooc-resolve.js'
import { ActivityOocReview } from './activity-ooc-review.js'

/* activity templates installation */
;[ActivityOocReview, ActivityOocResolve, ActivityDataCollect, ActivityDataReview].forEach(template => {
  ActivityInstallations.installActivityTemplate(template as any)
})
